import Vue from 'vue'
import Vuex from 'vuex'



Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId:"",
    replyTo:"recruit@maincorp.co.jp",
    password:"",
    mailTitle: "",
    item: "",
    itemSummary: "",
    period: "",
    place:"",
    price: "",
    skill: "",
    note: "",
    mailBody: "",
    destinations:"",
    
  },
  mutations: {
    mutationType(state, {userId,password,mailTitle,item,itemSummary,period,place,price,skill,note,mailBody,destinations,userName }) {
      state.userId = userId;
      state.password = password;
      state.mailTitle = mailTitle;
      state.item = item;
      state.itemSummary = itemSummary;
      state.period = period;
      state.place = place;
      state.price = price;
      state.skill = skill;
      state.note = note;
      state.mailBody = mailBody;
      state.destinations = destinations;
    }
  },
  actions: {

  }
})



// WEBPACK FOOTER //
// ./src/store.js